var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66 1.06V2.4H.34V1.06h2.32l.7-.66h3.3l.7.66h2.3ZM1 11.06v-8h8v8c0 .36-.13.67-.4.94-.27.27-.58.4-.94.4H2.34a1.3 1.3 0 0 1-.94-.4 1.3 1.3 0 0 1-.4-.94Z",
    fill: "#97A1BC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7e8cd1ba88b9a05aa11a78f7e2d68ebb.svg";
export { ForwardRef as ReactComponent };